'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'hat-wizard';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f6e8';
var svgPathData = ['M90.1 400l117.9 0 0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 182.3 0-73.6-171.7c-9.5-22.2-11-46.9-4.2-70.1l27.9-95.6-121.7 62.8c-32.4 16.7-58 43.9-72.8 77.2L90.1 400zM224 208c0-8.8 7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16z', 'M512 456c0-30.5-24.5-55.4-54.9-56l-79-184.3c-6.6-15.3-7.6-32.5-2.9-48.5L413.6 35.8c3.9-13.5-10.2-25.1-22.7-18.7L236 97c-38.8 20-69.6 52.7-87.4 92.6L55.1 400c-30.5 .5-55.1 25.4-55.1 56 0 30.9 25.1 56 56 56l400 0c30.9 0 56-25.1 56-56zM348.8 228.3l73.6 171.7-182.3 0 0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32-117.9 0 87.7-197.3c14.8-33.3 40.5-60.5 72.8-77.2l121.7-62.8-27.9 95.6c-6.7 23.1-5.2 47.9 4.2 70.1zM480 456c0 13.3-10.7 24-24 24L56 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l400 0c13.3 0 24 10.7 24 24zM288 176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHatWizard = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;